import React from "react";

export default function CSS_Website() {
  return (
    <div className="tutorial-page">
      <h1>CSS Website</h1>
      <p>This is the CSS Website tutorial page.</p>
    </div>
  );
}
